import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";

import { CalendarComponent } from "./calendar.component";
import { CalendarDirective } from "./calendar.directive";
import { DayComponent } from "./day/day.component";
import { MonthComponent } from "./month/month.component";
import { MonthsComponent } from "./months/months.component";
import { QuickNavigationComponent } from "./quick-navigation/quick-navigation.component";
import { WeekComponent } from "./week/week.component";
import { YearsComponent } from "./years/years.component";

@NgModule({
  declarations: [
    QuickNavigationComponent,
    CalendarComponent,
    YearsComponent,
    MonthsComponent,
    MonthComponent,
    WeekComponent,
    DayComponent,
    CalendarDirective,
  ],
  imports: [CommonModule],
  providers: [DatePipe],
  exports: [
    QuickNavigationComponent,
    CalendarComponent,
    YearsComponent,
    MonthsComponent,
    MonthComponent,
    WeekComponent,
    DayComponent,
    CalendarDirective,
  ],
})
export class CalendarModule {}
